import { useDroppable } from "@dnd-kit/core";
import { Plus } from "lucide-react";
import { cn } from "@/utils/cn";
import { KanbanCard, type TicketCard } from "./KanbanCard";
import type { ColumnType } from "./KanbanBoard";

interface KanbanColumnProps {
  column: ColumnType;
  tickets: TicketCard[];
}

export function KanbanColumn({ column, tickets }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: column.id,
  });

  return (
    <div
      className={cn(
        "flex h-full w-[320px] flex-col rounded-[14px] bg-[#F1F5F9] transition-all duration-200",
        isOver && "ring-2 ring-[#2563EB] ring-offset-2 bg-blue-50/50"
      )}
    >
      {/* Column Header */}
      <div className="sticky top-0 z-10 flex items-center justify-between rounded-t-[14px] bg-[#F1F5F9] px-4 py-3">
        <div className="flex items-center gap-2.5">
          <div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: column.color }}
          />
          <h3 className="text-sm font-semibold text-[#0F172A]">
            {column.title}
          </h3>
          <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#E2E8F0] px-1.5 text-xs font-semibold text-[#64748B]">
            {tickets.length}
          </span>
        </div>
        <button
          className="flex h-7 w-7 items-center justify-center rounded-lg text-[#64748B] transition-colors hover:bg-[#E2E8F0] hover:text-[#0F172A]"
          title="Adicionar ticket"
        >
          <Plus className="h-4 w-4" />
        </button>
      </div>

      {/* Cards Container */}
      <div
        ref={setNodeRef}
        className="flex flex-1 flex-col gap-3 overflow-y-auto px-3 pb-3 pt-1"
        style={{ maxHeight: "calc(100vh - 240px)" }}
      >
        {tickets.length === 0 ? (
          <div className="flex flex-1 items-center justify-center py-8">
            <p className="text-sm text-[#94A3B8]">Nenhum ticket</p>
          </div>
        ) : (
          tickets.map((ticket) => (
            <KanbanCard key={ticket.id} ticket={ticket} />
          ))
        )}
      </div>
    </div>
  );
}